export default __webpack_public_path__ + "static/matt-video-diary-038746df3ff1235cad75015dedf886fc.jpg";